import React from 'react';

function Logo({ isHome, width, ...props }) {
  return (
    <img
      width={width ?? 50}
      alt="Logo"
      src={isHome ? "/static/home.png" : "/static/logo.png"}
      {...props}
    />
  );
}

export default Logo;
